import { ref } from 'vue';

const isConvoAllFiltersButton = ref(false);

export default function useConvoAllFiltersButton() {
  return isConvoAllFiltersButton;
}
